import type { EditorHistoryCommand } from '@/editor/history/types'
import { getMockupHistoryBridge } from '@/editor/history/mockupEditorBridge'
import type { EasingPreset } from '@/types/easingPreset'

/**
 * 修改选中 clip 的缓动预设。
 */
export class SetClipEasingPresetCommand implements EditorHistoryCommand {
  readonly label = 'Clip easing'

  private readonly layerId: string

  private readonly clipId: string

  private readonly before: EasingPreset

  private readonly after: EasingPreset

  /**
   * @param layerId - 图层 id
   * @param clipId - 片段 id
   * @param before - 旧预设
   * @param after - 新预设
   */
  constructor(layerId: string, clipId: string, before: EasingPreset, after: EasingPreset) {
    this.layerId = layerId
    this.clipId = clipId
    this.before = before
    this.after = after
  }

  /** @inheritdoc */
  revert(): void {
    this.write(this.before)
  }

  /** @inheritdoc */
  redo(): void {
    this.write(this.after)
  }

  /**
   * @param p - 预设
   */
  private write(p: EasingPreset): void {
    const layer = getMockupHistoryBridge().animationLayers.value.find((l) => l.id === this.layerId)
    const clip = layer?.clips.find((c) => c.id === this.clipId)
    if (clip) clip.easingPreset = p
  }
}
